// Section 8: Weaver. 1.0 cloth from 1.5 fibre; gated by the loom (included in the workshop,
// which also gives 1.5x). Constants: config.jobs.weaver.
import type { Config } from '../../config';
import { alwaysEligible } from '../../core/content-helpers';
import { defineJob, noModifiers } from '../../core/registry';

export function weaver(config: Config) {
  const c = config.jobs.weaver;

  return defineJob({
    id: 'weaver',
    label: 'Weaver',
    section: 'S8',
    heavy: false,
    output: { kind: 'stock', resource: 'cloth' },
    baseYield: c.yield,
    toolFactor: null,
    toolWear: 0,
    risks: {},
    riskIllness: null,
    requiresBuilding: 'workshop',
    minStrength: 0,
    modifierTargets: [],
    modifiers: noModifiers,
    produce(ctx, _worker, output) {
      const made = Math.max(0, Math.min(output, ctx.state.stocks.fibre.amount / c.fibrePerCloth));
      if (made <= 0) return [];
      return [
        { kind: 'stock', resource: 'fibre', amount: -made * c.fibrePerCloth, flow: 'consumption' },
        { kind: 'stock', resource: 'cloth', amount: made, flow: 'production' },
      ];
    },
    eligible: alwaysEligible,
  });
}
